export const forBusiness_graphics_matter = [
	{
		icon: '🖼',
		subtitle: 'matterData_subtitle1',
	},
	{
		icon: '⏳',
		subtitle: 'matterData_subtitle2',
	},
	{
		icon: '💁‍♀️',
		subtitle: 'matterData_subtitle3',
	},
	{
		icon: '💪',
		subtitle: 'matterData_subtitle4',
	},
	{
		icon: '🚀',
		subtitle: 'matterData_subtitle5',
	},
];
